export const isAcceptableFailure = (statusCode: number | undefined) =>
	!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;
